import React, { useLayoutEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { resetLayoutsToEmpty } from "store/actions/layout.js";
import useAppInsightsHandler from "hooks/useAppInsightsHandler.js";

import { focusDefaultTabInAlarms } from "utils/insightsAndAlarmsUtils";
import getLogger from "utils/logger.util.js";
import { getAlarmsPagePath } from "utils/router.utils";
import { formatDateLocalTZ, isEllipsisActive } from "utils/utils";
import { DATE_FORMAT_WITH_BITWISEOR } from "constants/globalConstants";

import { DupontTooltip } from "components/DupontTooltip";

import { toggleAlarmReadStatusApi } from "../../../api/alarmsList";
import AlertTriangle from "../../../assets/Alarms/alert-triangle-grey.svg";

const NotificationItem = ({ notification, onClick, parentCallback }) => {
  const { alarmId, sysId, sysName, timestamp, description, readStatus } = notification;
  const [systemNameEllipse, setSystemNameEllipse] = useState(false);
  const systemNameRef = useRef(null);
  const [systemDescriptionEllipse, setSystemDescriptionEllipse] = useState(false);
  const systemDescriptionRef = useRef(null);
  const objAppInsights = useAppInsightsHandler();
  const dispatch = useDispatch();
  const Logger = getLogger("NotificationItem");

  useLayoutEffect(() => {
    setSystemNameEllipse(isEllipsisActive(systemNameRef));
  }, [systemNameRef?.current?.scrollWidth]);

  useLayoutEffect(() => {
    setSystemDescriptionEllipse(isEllipsisActive(systemDescriptionRef));
  }, [systemDescriptionRef?.current?.scrollWidth]);

  const handleMarkRead = e => {
    try {
      focusDefaultTabInAlarms();
      objAppInsights.trackEvent("alarmReadToggle");
      const toggleAlarmReadStatus = async () => {
        try {
          let newReadStatus,
            alarmReadStatusUpdateFlag = 0;
          if (e.currentTarget.className === "rightSection") {
            if (readStatus === 0) {
              newReadStatus = 1;
              alarmReadStatusUpdateFlag = 1;
            } else {
              alarmReadStatusUpdateFlag = 0;
            }
            dispatch(resetLayoutsToEmpty());
            onClick();
          } else {
            if (readStatus === 0) {
              newReadStatus = 1;
            } else {
              newReadStatus = 0;
            }
            alarmReadStatusUpdateFlag = 1;
          }
          if (alarmReadStatusUpdateFlag === 1) {
            const response = await toggleAlarmReadStatusApi(sysId, alarmId, newReadStatus);
            if (response && response.status >= 200 && response.status < 300) {
              notification.readStatus = newReadStatus;
              parentCallback(sysId, alarmId, newReadStatus);
            }
          }
        } catch (err) {
          Logger.error("toggleAlarmReadStatus - error: ", err);
        }
      };
      toggleAlarmReadStatus();

      if (e.currentTarget === "div.rightSection") {
        onClick();
      }
    } catch (error) {
      Logger.log("handleMarkRead", error);
    }
  };

  const getFormatteTimeStamp = () => formatDateLocalTZ(timestamp, DATE_FORMAT_WITH_BITWISEOR);
  return (
    <li className="whiteBackground border-bottom__light-grey notificationItem pointer">
      <div className={readStatus === 0 ? "unreadAlarmLeftSection" : "readAlarmLeftSection"} onClick={handleMarkRead} />
      <Link to={getAlarmsPagePath(sysId)} key={sysId}>
        <div className="rightSection" onClick={handleMarkRead}>
          <div className="flex-ai-center">
            <img className="alertTriangle" src={AlertTriangle} alt="alert-triangle" />
            <div className="alarms__card--title">{alarmId}</div>
          </div>
          <span className="grayColor font12">{getFormatteTimeStamp()}</span>
          <DupontTooltip title={sysName} placement="bottom-start" type={systemNameEllipse ? "primary" : "none"}>
            <span ref={systemNameRef} className={`overflow ${readStatus === 0 ? "unreadAlarmSystemName" : "readAlarmSystemName"}`}>
              {sysName}
            </span>
          </DupontTooltip>
          <DupontTooltip title={description} placement="bottom-start" type={systemDescriptionEllipse ? "primary" : "none"}>
            <span ref={systemDescriptionRef} className={` ${readStatus === 0 ? "unreadAlarmDescription" : "readAlarmDescription"} overflow`}>
              {description}
            </span>
          </DupontTooltip>
        </div>
      </Link>
    </li>
  );
};

export default NotificationItem;
